<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-dollar"></i>
      <span>Affiliate</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/affiliate-dashboard">Dashboard</router-link></li>
      <li><router-link to="/affiliate-redeem">Redeem</router-link></li>
      <li><router-link to="/affiliate-setting">Setting</router-link></li>
    </ul>
  </li>
</template>
<script>
export default {
  name: "affiliate-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?8c407b32